var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"sidebar"},[_c('v-uni-view',{staticClass:"item",on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.handleUserInfo()
}}},[_c('v-uni-view',{staticClass:"icon userInfo"}),_c('v-uni-view',{staticClass:"desc"},[_vm._v("个人中心")])],1),_c('v-uni-view',{staticClass:"item",on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.handleDownload()
}}},[_c('v-uni-view',{staticClass:"icon app"}),_c('v-uni-view',{staticClass:"desc"},[_vm._v("App下载")])],1),_c('v-uni-view',{staticClass:"item",on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.handleService()
}}},[_c('v-uni-view',{staticClass:"icon consult"}),_c('v-uni-view',{staticClass:"desc"},[_vm._v("我要咨询")])],1),_c('v-uni-view',{staticClass:"item",on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.toTop()
}}},[_c('v-uni-view',{staticClass:"icon back"}),_c('v-uni-view',{staticClass:"desc"},[_vm._v("回到顶端")])],1)],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }